module.exports = __webpack_public_path__ + "static/media/page-title.628041bf.jpg";